import { ReportColumn } from 'types';
import { useReportColumns } from '../../../../hooks';

export const useOutstandingResponseColumns = (): ReportColumn[] => {
  const {
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    consultationStatus,
  } = useReportColumns();

  return [
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    consultationStatus,
  ];
};
